export default "__VITE_PUBLIC_ASSET__3446f364__"